import { render, staticRenderFns } from "./canteen.vue?vue&type=template&id=43d24a69&scoped=true"
import script from "./canteen.vue?vue&type=script&lang=js"
export * from "./canteen.vue?vue&type=script&lang=js"
import style0 from "./canteen.vue?vue&type=style&index=0&id=43d24a69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d24a69",
  null
  
)

export default component.exports